import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  PiUserCircleThin,
  PiListChecks,
  PiMapPinLine,
  PiHeart,
  PiBell,
  PiArrowUUpLeft,
  PiGift,
} from "react-icons/pi";
import { RiLogoutCircleLine } from "react-icons/ri";
import { useCustomer } from "../../context/CustomerContext";
import { useWishlist } from "../../context/WishlistContext";
import styles from "./UserCabinet.module.css";
import { useLoyaltySettings } from "../../context/LoyaltySettingsContext";

const navLinks = [
  { to: "profile", label: "Профіль", description: "Особисті дані", icon: <PiUserCircleThin size={22} /> },
  { to: "orders", label: "Мої замовлення", description: "Історія покупок", icon: <PiListChecks size={22} /> },
  {
    to: "loyalty",
    label: "Бонуси",
    description: "Баланс та історія бонусів",
    icon: <PiGift size={22} />,
  },
  {
    to: "addresses",
    label: "Адреси доставки",
    description: "Нова пошта та кур'єр",
    icon: <PiMapPinLine size={22} />,
  },
  { to: "wishlist", label: "Обрані товари", description: "Товари для майбутніх покупок", icon: <PiHeart size={22} /> },
  { to: "subscriptions", label: "Підписки", description: "Налаштування повідомлень", icon: <PiBell size={22} /> },
  {
    to: "returns",
    label: "Повернення товарів",
    description: "Історія повернень",
    icon: <PiArrowUUpLeft size={22} />,
  },
];

const getCustomerInitials = (customer) => {
  const initials = [customer?.firstName, customer?.lastName]
    .filter(Boolean)
    .map((part) => String(part).trim().charAt(0))
    .join("");

  return initials || "MZ";
};

const UserCabinet = () => {
  const navigate = useNavigate();
  const { settings: loyaltySettings } = useLoyaltySettings();
  const { customer, logout } = useCustomer();
  const { clearUserWishlistState, wishlist } = useWishlist();

  const customerName = [customer?.firstName, customer?.lastName]
    .filter(Boolean)
    .join(" ");
  const wishlistCount = Array.isArray(wishlist) ? wishlist.length : 0;

  const handleLogout = async () => {
    clearUserWishlistState();
    await logout();
    navigate("/");
  };

  return (
    <div className={styles.cabinetRoot}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarProfileCard}>
          <div className={styles.sidebarAvatar} aria-hidden="true">
            {getCustomerInitials(customer)}
          </div>
          <div className={styles.sidebarProfileInfo}>
            <span className={styles.sidebarEyebrow}>{loyaltySettings?.visible ? "MyZooShop Club" : "MyZooShop"}</span>
            <strong>{customerName || "Покупець MyZooShop"}</strong>
            <span>{customer?.email || "Персональний кабінет"}</span>
          </div>
        </div>

        <div className={styles.sidebarSectionHeader}>
          <PiGift size={18} />
          <span>Кабінет покупця</span>
        </div>

        <div className={styles.sidebarNavScroll}>
          <nav className={styles.sidebarNav}>
            {navLinks.filter((item) => item.to !== "loyalty" || loyaltySettings?.visible).map((item) => (
              <NavLink
                to={item.to}
                key={item.to}
                className={({ isActive }) =>
                  `${styles.sidebarNavLink} ${isActive ? styles.active : ""}`
                }
                end
              >
                <span className={styles.navIcon}>{item.icon}</span>
                <span className={styles.navText}>
                  <span>{item.label}</span>
                  <small>{item.description}</small>
                </span>
                {item.to === "wishlist" && wishlistCount > 0 && (
                  <span className={styles.navBadge}>{wishlistCount}</span>
                )}
              </NavLink>
            ))}
            <button
              className={styles.sidebarLogoutButton}
              onClick={handleLogout}
              type="button"
            >
              <span className={styles.navIcon}>
                <RiLogoutCircleLine size={22} />
              </span>
              <span className={styles.navText}>
                <span>Вийти</span>
                <small>Завершити сесію</small>
              </span>
            </button>
          </nav>
        </div>
      </aside>
      <section className={styles.cabinetContent}>
        <div className={styles.contentWrapper}>
          <Outlet />
        </div>
      </section>
    </div>
  );
};

export default UserCabinet;
